<template>
    <AuroraArtIcon v-if="iconName" class="aurora-category-icon" :name="iconName" />
    <img v-else class="aurora-category-image" :src="imageUrl" alt="" @error="$emit('error', $event)">
</template>

<script>
import AuroraArtIcon from './artIcon.vue'
import { categoryIcons } from './icons'

export default {
    name: 'AuroraCategoryIcon',
    components: { AuroraArtIcon },
    props: {
        category: { type: Object, required: true },
        active: { type: Boolean, default: true }
    },
    computed: {
        iconName() {
            return categoryIcons[this.category.gameCategoryType] || categoryIcons[this.category.id] || ''
        },
        imageUrl() {
            return this.active ? this.category.activationImg : this.category.unActivationImg
        }
    }
}
</script>
